export default __webpack_public_path__ + "static/company-values-ec98e3cec26dad85924459ced7902df9.webp";